export const ACCOUNT_CLEAR_STORE = "ACCOUNT_CLEAR_STORE";

export const ACCOUNT_LIST_LOAD_START = "ACCOUNT_LIST_LOAD_START";
export const ACCOUNT_LIST_LOAD_SUCCESS = "ACCOUNT_LIST_LOAD_SUCCESS";
export const ACCOUNT_LIST_LOAD_FAIL = "ACCOUNT_LIST_LOAD_FAIL";

export const ACCOUNT_ITEM_REMOVE_START = "ACCOUNT_ITEM_REMOVE_START";
export const ACCOUNT_ITEM_REMOVE_SUCCESS = "ACCOUNT_ITEM_REMOVE_SUCCESS";
export const ACCOUNT_ITEM_REMOVE_FAIL = "ACCOUNT_ITEM_REMOVE_FAIL";
